export const IS_PRODUCTION = process.env.NODE_ENV === 'production'
export const BRIDGE_BASE_URL = process.env.VUE_APP_BRIDGE_BASE_URL || 'http://localhost:8600/go/'

export const HTTP_HEADER_SKIP_ERROR = 'UT-Skip-Error'
export const HTTP_STATUS = {
  badRequest: 400,
  unauthrized: 401,
  unprocessableEntity: 422
}

export const STORAGE_ITEM = {
  authToken: 'authTokenBetUT'
}

export const AUTH_COOKIE = {
  name: 'beu_ut__auth',
  expires: 365,
  path: '/'
}

if (IS_PRODUCTION) {
  AUTH_COOKIE.domain = '.beusable.net'
}

export const TOAST_TIMER = 3000

export const UT_ITEM_TYPE_LIST = [
  { text: '라디오버튼 (단일응답)', value: 'radio', default: true },
  { text: '체크박스 (다중응답)', value: 'checkbox', default: false }
]

export const SELECT_LANGUAGE_LIST = [
  { text: '한국어', value: 'ko', default: true }
]

export const SELECT_TIMEZONE_LIST = [
  { text: '(+09:00) Asia/Seoul', value: '(+09:00) Asia/Seoul', default: true }
]

export const ERROR_MSG = {
  username: {
    empty: '이메일을 입력해주세요.',
    notfound: '가입되지 않은 아이디입니다.',
    unactivated: '이메일 인증 요청 중인 아이디입니다.',
    unable: '사용할 수 없는 아이디입니다.'
  },
  password: {
    empty: '비밀번호를 입력해주세요.',
    length: '비밀번호는 6자 이상이어야 합니다.',
    wrong: '비밀번호를 다시 확인해 주세요.'
  },
  testName: {
    empty: '테스트 제목을 입력해주세요.'
  },
  contact: {
    empty: '담당자 연락처를 입력해주세요.'
  },
  url: {
    empty: 'URL을 입력해주세요.',
    unable: 'URL 형식으로 입력해주세요.'
  },
  contents: {
    empty: '테스트 내용을 입력해주세요.'
  },
  question: {
    subject: {
      empty: '질문 내용을 입력해주세요.'
    },
    item: {
      empty: '문항 내용을 입력해주세요.'
    }
  }
}

export const RESULT_CHART_COUNT = 4
export const RESULT_CHART_ORDER_COLOR = ['#1199af', '#9fce12', '#deaf00', '#baa7d5']
export const RESULT_ORDER_COLOR_CSS = ['blue', 'green', 'orange', 'purple']
export const ITEM_TYPE_TEXT = {
  checkbox: '다중응답',
  radio: '단일응답'
}

export const DOCUMENT_TITLE_PREFIX = 'Beusable UT'

export const DEFAULT_TIMEZONE = '+09:00'
export const DEFAULT_TIMEZONE_NAME = 'Asia/Seoul'
